const COLORS = {
  white100: "#eee",
  white: "#fff",
  black: "#333",
};

export { COLORS };
